export default (value) => {
    if (value.trim() === '') {
        return 'Email harus diisi!'
    } else if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value)) {
        return 'Email tidak valid!'
    }

    return true;
}